"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONCAT = void 0;
exports.CONCAT = {
    alias: 'CONCAT',
    description: 'Concatena 2 ou mais strings',
    arg_names: ['primeira_string', 'proximas_strings'],
    args_description: ['primeira string', 'proximas strings (parâmetro repetível)'],
};
